import React from 'react';
import { TabItems } from './tabInterface';
import { Nav, Tab } from 'react-bootstrap';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import './StandardTab.scss';
import { LogType } from 'utils/enums/misc';

interface StandardTabProps {
  data: TabItems[];
  activeKey: LogType | null;
  onChange: React.Dispatch<React.SetStateAction<LogType | null>>;
}

const StandardTab = (props: StandardTabProps) => {
  return (
    <Tab.Container
      activeKey={props.activeKey as string}
      onSelect={(e: string | null) => (e ? props.onChange(e as LogType) : null)}
    >
      <ConditionalRender condition={props.data.length > 0}>
        <Nav variant="underline" className="mb-3">
          {props.data.map((tab, index) => {
            return (
              <Nav.Item key={`tab-items-${index}`} className="tab-nav-item">
                <Nav.Link eventKey={tab.activeId}>{tab.label}</Nav.Link>
              </Nav.Item>
            );
          })}
        </Nav>
      </ConditionalRender>
    </Tab.Container>
  );
};

export default StandardTab;
